import { createFileRoute } from '@tanstack/react-router';
import { RoutePlaceholder } from './-components/RoutePlaceholder';

export const Route = createFileRoute('/profile/deposit-limits')({
  component: () => (
    <RoutePlaceholder
      icon="filters"
      title="Deposit Limits"
      description="Set soft deposit limits for responsible gaming."
    />
  ),
});
